import { AfterContentChecked, Component, HostBinding } from "@angular/core";
import { environment } from "environments/environment";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterContentChecked {

  public version: string = environment.VERSION;
  @HostBinding('class.transparent') classTransparent = false;

  isTransparent: boolean = false;
  transparentFooterRoutes: string[] = [
    '/login',
    '/novasenha',

  ];

  constructor() {
    this.classTransparent = this.isTransparentFooter();
  }

  ngAfterContentChecked() {
    this.classTransparent = this.isTransparentFooter();
  }

  isTransparentFooter(): boolean {
    const hash = location.hash;
    let matchedRoute = false;

    if (this.transparentFooterRoutes.length) {
      this.transparentFooterRoutes.forEach((route) => {
        if (hash.match(new RegExp(route, 'gi'))) {
          matchedRoute = true;
        }
      })
    }

    return matchedRoute;
  }

}
